import React, { FC, useMemo, useState } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useTranslation } from "react-i18next";

import {
  ActionsGroup,
  DialogActions,
  DialogContent,
  DialogTitle,
  FlatButton,
  IconButton,
  WaitingButton,
} from "@evergis/ui";

import { ModalDialog } from "../../DialogComponents/ModalDialog";
import { BulkCopyDialogContent } from "./BulkCopyDialogContent";

import { useCheckLimits } from "../../../../hooks/useCheckLimits";
import { useToggle } from "../../../../hooks/useToggle";
import { useResourceType } from "../../../../hooks/useResourceType";
import { useDialogReset } from "../../../../hooks/useDialogs";
import { useGetDialogSettings } from "../hooks/useGetDialogSettings";

export const DIALOG_STYLE = {
  maxWidth: "40rem",
};

export const BulkCopy: FC = () => {
  const { t } = useTranslation("common");
  const [resourceType] = useResourceType();
  const closeDialog = useDialogReset();
  const [copyLayers, toggleLayers] = useToggle(true);
  const [copyTables, toggleTables] = useToggle(true);
  const [typeName, job] = useGetDialogSettings({ copyLayers, copyTables });
  const { onCopy, waiting } = job();
  const [loading, setLoading] = useState(true);
  const { limits } = useCheckLimits();

  const dialogMinHeight = useMemo((): string => {
    switch (resourceType) {
      case ResourceTypeLink.Project:
        return "23.5rem";
      case ResourceTypeLink.Layer:
        return "21.5rem";
      default:
        return "auto";
    }
  }, [resourceType]);

  return (
    <ModalDialog maxWidth={DIALOG_STYLE.maxWidth} minHeight={dialogMinHeight}>
      <DialogTitle>
        <ActionsGroup>
          {t("actions.copy")} {typeName}
        </ActionsGroup>
        <ActionsGroup>
          <IconButton kind="close" onClick={closeDialog} />
        </ActionsGroup>
      </DialogTitle>
      <DialogContent>
        <BulkCopyDialogContent
          copyLayers={copyLayers}
          copyTables={copyTables}
          toggleLayers={toggleLayers}
          toggleTables={toggleTables}
          onLoading={setLoading}
          limits={limits}
        />
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <WaitingButton primary onClick={onCopy} disabled={loading} isWaiting={waiting}>
            {t("actions.copy")}
          </WaitingButton>
          <FlatButton onClick={closeDialog}>{t("actions.cancel")}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </ModalDialog>
  );
};
